import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';
import { FundamentalProcessService } from '../proxy/general/controllers/fundamental-process.service';

FieldBuilder.setNamespace('General');

export const MAINPROCESS_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.MainProcess.Name')
    .required()
    .maxLength(100)
    .build(),
  FieldBuilder
    .text('code', 'Entity.MainProcess.Code')
    .required()
    .maxLength(10)
    .build(),
  FieldBuilder.foreignKey(
    'fundamentalProcessId',
    'Entity.FundamentalProcess',
    FundamentalProcessService
  )
    .required()
    .displayFromNested('fundamentalProcess.name')
    .sortBy('fundamentalProcess.name')
    .build(),
];

export const MAINPROCESS_CONFIG = {
  entityName: 'MainProcess',
  localizationKey: 'General::Entity.MainProcess',
  fields: MAINPROCESS_FIELDS,
  permission: 'ControllingProcess.MainProcesses',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Controlling + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Processes + MENU_NAME_SUFFIX,
};
